import { type HttpClient } from '../useHttpClient';

export const postLeaveChannel =
  (httpClient: HttpClient) => async (channelUrl: string) => {
    await httpClient.api(`/sendbird/channels/${channelUrl}/leave`, {
      method: 'POST',
    });
  };
